import InfoModal from './InfoModal.view';

export default InfoModal;
